<template>
    <div v-if="news"
        class="list-news w-full flex flex-col md:flex-row flex-wrap items-start justify-start px-4 md:px-32">
        
        <TransitionGroup name="list">
            <div v-for=" (post, index) in news " :key="index" class="w-full md:w-1/3 mb-48 px-20 wrap-single-news">
                <post-news :data-post="post" />
            </div>
        </TransitionGroup>
        <div class="limit-list-news w-full py-8 relative" ref="scrollRef"><loader :loading="state.isLoading" /></div>
      
    </div>
</template>

<script>
import { ref, onMounted, reactive} from 'vue'
import { onIntersect } from '../../scripts/onintersect'
import { getNews } from '../../scripts/getAxios'
export default {
    name: 'list-news',
    setup() {
        const news = ref([])
        const scrollRef = ref({})
        const last_page = ref(0)
       
        const params = {
            per_page: 12,
            page: 1
        }

        const state = reactive({
            sectionObserver: null,
            isLoading :false
        })
        const observeSections = () => {
            const options = {
                root: null,
                rootMargins: '0px',
                threshold: 0.1
            }
            state.sectionObserver = new onIntersect(scrollRef.value, sectionObserveHandler, null, false, options)
            
        }

        const sectionObserveHandler = () => {
            if (params.page < last_page.value) {
                params.page = params.page + 1
                state.isLoading = true
                importNews();

            }else if (params.page == last_page.value){
                state.sectionObserver = observe().disconnect
            }
        }

        const importNews = async () => {
            await getNews(`${process.env.WORDPRESS_BASE_URL}/wp-json/wp/v2/posts`, params).then(response => {
                news.value.push(...response.data)
                last_page.value = response.headers['x-wp-totalpages']

            })
            state.isLoading = false
        }

        onMounted(async () => {
            importNews()
            observeSections()
        })
        return {
            news,
            scrollRef,
            last_page,
            state
        }
    },



}
</script>

<style lang="scss" scoped>
.list-enter-active,
.list-leave-active {
    transition: all 1s ease-in;
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
}
</style>